import { user, data } from 'services';
import { getDate, getVehicleClassById } from 'services/types';
import { ParkingCell, StatusCell } from 'libs/ui';
import { DelSetForm, /* StatusSetForm,*/ TariffSetForm, DateSetForm, CategorySetForm, ClassSetForm } from 'libs/forms';

export const getTableParams = (t) => {
  const setRight = user.haveRight('plates.bulk');

  const setActions = setRight
    ? [
        {
          title: 'Удалить',
          key: 'del',
          form: DelSetForm,
          simple: true,
          method: 'plates.bulk_delete',
          idsParam: 'ids',
          isDanger: true,
        },
        // {
        //   title: 'Статус',
        //   key: 'status',
        //   form: StatusSetForm,
        //   dict: 'rfid.status',
        //   dictExclude: ['blocked_by_client'],
        //   simple: false,
        //   method: 'plates.bulk_change_status',
        //   idsParam: 'ids',
        // },
        {
          title: 'Тариф',
          key: 'tariff',
          form: TariffSetForm,
          dict: 'rfid.status',
          simple: false,
          method: 'plates.bulk_update_tariff',
          idsParam: 'ids',
        },
        {
          title: 'Категория',
          key: 'tscategory',
          form: CategorySetForm,
          simple: false,
          method: 'plates.bulk_change_vehicle_category',
          idsParam: 'ids',
        },
        {
          title: 'Класс ТС',
          key: 'tsclass',
          form: ClassSetForm,
          simple: false,
          method: 'plates.bulk_change_vehicle_class',
          idsParam: 'ids',
        },
        {
          title: 'Действует по',
          key: 'dateto',
          form: DateSetForm,
          simple: false,
          method: 'plates.bulk_change_end_at',
          idsParam: 'ids',
        },
      ]
    : [];

  // get row class
  const getRowClass = (row) => {
    let out = '';
    out += ' ' + row.status;
    return out;
  };

  const getFields = (props) => {
    const fields = [
      { name: 'mean_id', title: t('sections.ГРЗ'), width: 170, sortField: 'mean_id' },
      {
        name: 'is_blocked',
        title: t('dict_filter.Список'),
        width: 120,
        renderCell: true,
        style: { paddingLeft: '15px' },
        render: (val, other) => {
          const title = data.getDictValue('plates.list', val);
          // console.log("other", other);
          return (
            <StatusCell {...other} status={!val ? 'active' : 'blocked'}>
              {title}
            </StatusCell>
          );
        },
      },
      {
        name: 'start_at',
        title: t('form.Дата действия с'),
        width: 210,
        sortField: 'start_at',
        render: (val) => getDate(val),
      },
      {
        name: 'end_at',
        title: t('form.Дата действия по'),
        width: 210,
        sortField: 'end_at',
        render: (val) => getDate(val),
      },
    ];
    if (!props.clientId) {
      fields.push({ name: 'client_name', title: t('form.Клиент'), width: 145 });
    }
    fields.push({
      name: 'vehicle_class',
      title: t('dict_filter.Класс ТС'),
      width: 160,
      sortField: 'vehicle_class',
      render: (val) => getVehicleClassById(val),
    });
    fields.push({ name: 'comment', title: t('form.Причина внесения'), width: 360 });
    fields.push({ name: 'owner', title: t('form.Инициатор'), sortField: 'owner' });

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: 140,
      });
    }

    return fields;
  };

  return { getFields, getRowClass, withComment: true, setActions };
};
